module.exports = __webpack_public_path__ + "img/download.855ef8ab.svg";